import "/node_modules/flag-icons/css/flag-icons.min.css"
import { useTranslation } from "react-i18next"
import { CaretDown } from "@phosphor-icons/react"
import { Chip } from "@/components/ui/chip"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { PATIENT_COUNTRY_FILTER_ITEMS } from "@/modules/patients/constants/Patient"
import { Country } from "@/types/__generated__/union-types"

type Props = {
  value?: Country
  isDisabled?: (item: Country) => boolean
  onChange: (item: Country) => void
  readOnly?: boolean
}

const CountryDropdown = ({ value, onChange, isDisabled, readOnly }: Props) => {
  const { t } = useTranslation()
  const label = PATIENT_COUNTRY_FILTER_ITEMS.find((item) => item.value === value)?.label

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild className="outline-hidden">
        <Chip data-testid="country-filter-trigger" className="h-8 gap-0.5" checked={true} type="button">
          <span className="px-1.5">{label ? t(label) : t("common.insuranceCountry")}</span>
          <CaretDown size={20} />
        </Chip>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="start"
        data-testid="country-dropdown-content"
        className="absolute -top-1 grid w-36.5 gap-2 rounded-md border-none p-2 leading-5">
        {PATIENT_COUNTRY_FILTER_ITEMS.map((item) => {
          const checked = value === item.value
          const disabled = !!isDisabled?.(item.value)

          return (
            <DropdownMenuCheckboxItem
              key={item.value}
              data-testid={`country-filter-item-${item.value}`}
              disabled={disabled}
              checked={checked}
              onCheckedChange={(checked) => {
                // There should always be 1 value
                if (readOnly) return
                if (checked) {
                  onChange(item.value)
                }
              }}>
              <span className={`fi fis fi-${item.value.toLowerCase()} mr-1.5 h-6! w-6! rounded-sm object-cover`}></span>
              {t(item.label)}
            </DropdownMenuCheckboxItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default CountryDropdown
